import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Update, GetById } from '../../service/LevelService';
import { GetAll } from '../../service/GiftService';

export default function LevelNew() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  const [name, setName] = useState('');
  const [sequence, setSequence] = useState('');
  const [referCount, setReferCount] = useState('');
  const [image, setImage] = useState(null);

  //read id from useParams
  const { id } = useParams();

  const [status, setStatus] = useState('active');
  const [level, setLevel] = useState({});

  // gift foreign key
  const [giftId, setGiftId] = useState('');
  const [gifts, setGifts] = useState([]);
  const [keyword, setKeyword] = useState('');


  const fetchLevelById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      if (response.status === 200) {
        setLevel(response.level);
        setName(response.level.name);
        setImage(response.level.image);
        setStatus(response.level.status);
        setSequence(response.level.sequence);
        setReferCount(response.level.referCount);
        setGiftId(response.level.gift.id);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
    console.log(file);
  };

  const FetchGift = async () => {
    setIsLoading(true);
    try {
      const response = await GetAll(1, 9999, keyword);
      if (response && Array.isArray(response.gifts)) {
        // Filter only active categories
        const activeGifts = response.gifts.filter(cat => cat.status === "active");
        setGifts(activeGifts);
      } else {
        setAppError(true);
        setAppErrorMessage('No Gift Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading master data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchGift();
  }, []);

  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchLevelById();
    }
  }, []);


  const saveLevel = async (event) => {
    event.preventDefault();

    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }

    /** 
    if (!image) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Image is required");
      setAppErrorMode("error");
      return;
    }
    */

    setIsLoading(true);

    try {
      const response = await Update(id, name, image, sequence, referCount, giftId, status);
      console.log("update", response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Level Successfully Added");
        setAppErrorMode("success");
        window.location.href = "/level/list";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to add level. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add level. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Level Manage | {config.appName}</title>
      </Helmet>
      <div className="container">
        <div className="page">
          <div className="page-heading">
            <h1>Level Add</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/level/list"> Level List </Link> / Level Manage
            </span>
          </div>
          <div className="page-content">
            <div className="portal">
              <div className="portal-body">
                <div className="form">
                  <form onSubmit={saveLevel} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Award</label>
                          <select
                            className="form-control"
                            value={giftId}
                            onChange={(e) => setGiftId(e.target.value)}
                          >
                            <option value="">Select Award</option>
                            {gifts.map(giftOption => (
                              <option key={giftOption.id} value={giftOption.id}>
                                {giftOption.name}
                              </option>
                            ))}
                          </select>

                        </div>
                      </div>
                      <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input
                            className='form-control'
                            type='text'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Image</label>
                          <input
                            className='form-control'
                            type='file'
                            onChange={handleFileChange}
                          />                         
                        </div>
                      </div>
                       <div className='col-lg-1 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <img
                            src={`${config.imageBasePath}/level/${level.id}.${level.image}`}
                            alt={level.name} className='img-fluid image-xs'
                            style={{ width: '100px', marginTop: '10px', height: '55px' }} />
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Sequence</label>
                          <input
                            className='form-control'
                            type='text'
                            value={sequence}
                            onChange={(e) => setSequence(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Refer Count</label>
                          <input
                            className='form-control'
                            type='text'
                            value={referCount}
                            onChange={(e) => setReferCount(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Status</label>
                          <br></br>
                          <input type='radio' name='status' value="active" onChange={(e) => setStatus(e.target.value)} checked={status === 'active'} /> Active &nbsp;&nbsp;
                          <input type='radio' name='status' value="inactive" onChange={(e) => setStatus(e.target.value)} checked={status === 'inactive'} /> Deactive
                        </div>
                      </div>
                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'>
                            <i className="ri-reset-right-line"></i> Reset
                          </button>
                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'>
                            <i className="ri-check-fill"></i> Update Level
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
